const React = require("react");

const AssetDetail = require("./generic/AssetDetail.jsx");
const MasterPage = require("./generic/MasterPage.jsx");
const UploadNewVersion = require("../controls/buttons/infoPageButtons/UploadNewVersion.jsx");
const PublicPrivateButton = require("../controls/buttons/infoPageButtons/PublicPrivateButton.jsx");
const DeleteInfoButton = require("../controls/buttons/infoPageButtons/DeleteInfoButton.jsx");
const BulkUploadModelsButton = require("../controls/buttons/infoPageButtons/BulkUploadModelsButton.jsx");

const LibraryPreview = require("../controls/preview/LibraryPreview.jsx");

class LibraryDetail extends React.Component {

    constructor() {
        super()
    }
    
    render() {
        return  <MasterPage
                    {...this.props}
                    renderPage={addedProps => 
                        <AssetDetail
                            {...addedProps}
                            {...this.props}
                            className="library"
                            urlName="libraries"
                            displayName="Library"
                            Preview={LibraryPreview}
                            buttons={[
                                UploadNewVersion,
                                BulkUploadModelsButton,
                                PublicPrivateButton,
                                DeleteInfoButton
                            ]}
                        /> 
                    }
                />
    }
}

module.exports = LibraryDetail;
